<template>
  <div id="home_wrapper" class="scroller">
    <div id="home" class="position-relative">
      <HeroRoof />

      <Events />

      <FeaturesEvents />

      <AppFooter />

      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  head: {
    title: "Explore the Roof | Ode Toronto",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        hid: "description",
        name: "description",
        content:
          "Elevate your special event at Ode's vibrant rooftop featuring two floors, colorful murals, and stunning city sunset views. Ideal for weddings, cocktail parties, corporate events, and more!",
      },
    ],
  },
  data() {
    return {
      intersectionObserver: null,
      parallaxElements: [],
      rafId: null,
    };
  },
  components: {
    Events: () => import("@/components/Roof/Events"),
    FeaturesEvents: () => import("@/components/Roof/FeaturesEvents"),
    AppFooter: () => import("@/components/Home/AppFooter"),
    HeroRoof: () => import("@/components/Roof/HeroRoof"),
  },
  mounted() {
    this.$nextTick(() => {
      this.$nuxt.$loading.start();
      setTimeout(() => this.$nuxt.$loading.finish(), 2500);
    });

    setTimeout(() => {
      this.initIntersectionObserver();
      this.initParallax();
    }, 500);
  },
  methods: {
    moveToSection(to) {
      const element = document.getElementById(to);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },

    initIntersectionObserver() {
      // Fade in up animations
      const fadeInUpElements = document.querySelectorAll(".fade-in-up-element");

      const observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      };

      this.intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            // Optionally unobserve after animation
            // this.intersectionObserver.unobserve(entry.target);
          }
        });
      }, observerOptions);

      fadeInUpElements.forEach((el) => {
        this.intersectionObserver.observe(el);
      });
    },

    initParallax() {
      // Parallax effect for .parallax elements
      this.parallaxElements = Array.from(
        document.querySelectorAll(".parallax")
      );

      if (this.parallaxElements.length > 0) {
        this.handleParallaxScroll();
        window.addEventListener("scroll", this.handleParallaxScroll, {
          passive: true,
        });
      }
    },

    handleParallaxScroll() {
      if (this.rafId) return;

      this.rafId = requestAnimationFrame(() => {
        const scrollY = window.pageYOffset;

        this.parallaxElements.forEach((section, i) => {
          if (i === 0) {
            this.rafId = null;
            return; // Skip first section
          }

          const bg = section.querySelector(".bg");
          if (!bg) return;

          const rect = section.getBoundingClientRect();
          const sectionTop = rect.top + scrollY;
          const sectionHeight = rect.height;
          const windowHeight = window.innerHeight;

          // Calculate parallax offset
          const scrollProgress =
            (scrollY + windowHeight - sectionTop) /
            (sectionHeight + windowHeight);
          const offset = (scrollProgress - 0.5) * windowHeight;

          bg.style.transform = `translateY(${offset * 0.3}px)`;
        });

        this.rafId = null;
      });
    },
  },

  beforeDestroy() {
    // Clean up
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }

    window.removeEventListener("scroll", this.handleParallaxScroll);

    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
    }
  },
};
</script>

<style scoped>
/* Smooth scrolling */
#home_wrapper {
  scroll-behavior: smooth;
}

/* Fade in up animation */
.fade-in-up-element {
  opacity: 0;
  transform: translateY(100px);
  transition: opacity 1s ease-out, transform 1s ease-out;
}

.fade-in-up-element.is-visible {
  opacity: 1;
  transform: translateY(0);
}

/* Parallax background positioning */
.parallax .bg {
  transition: transform 0.1s ease-out;
  will-change: transform;
}
</style>
